import { Component } from '@angular/core';

@Component({
  selector: 'naas-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class FooterComponent {
  themeListener() {
    const themeSwitcher = document.querySelector('#theme') as HTMLSelectElement;
    const themeoptions = themeSwitcher?.querySelectorAll('option');
    const themeStore = 'noteableThemeStore';
    const preferredTheme = localStorage.getItem(themeStore);

    // set the inital checked theme
    if (preferredTheme === 'light') {
      checkThemeOption('light');
    } else if (preferredTheme === 'dark') {
      checkThemeOption('dark');
    } else {
      checkThemeOption('light dark');
    }

    function checkThemeOption(graphic: string) {
      themeoptions?.forEach(option => {
        if (option.getAttribute('value') === graphic) {
          option.setAttribute('selected', 'true');
        } else {
          option.removeAttribute('selected');
        }
      });
    }

    document.documentElement.style.colorScheme = themeSwitcher.value;
    localStorage.setItem(themeStore, themeSwitcher.value);
    checkThemeOption(themeSwitcher.value);
  }
  // ngAfterViewInit(): void {};
}
